module.exports = __webpack_public_path__ + "static/media/rightArrow.89073a76.svg";